module.exports = __webpack_public_path__ + "img/DSC09213.9c076e0c.webp";